import { render, staticRenderFns } from "./AcceptContractModal.vue?vue&type=template&id=8bb0e2b2"
import script from "./AcceptContractModal.vue?vue&type=script&lang=js"
export * from "./AcceptContractModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports